import { render, staticRenderFns } from "./MenuExtHeader.vue?vue&type=template&id=c54f7a24&"
import script from "./MenuExtHeader.vue?vue&type=script&lang=js&"
export * from "./MenuExtHeader.vue?vue&type=script&lang=js&"
import style0 from "./MenuExtHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
